import React from 'react'
import PropTypes from 'prop-types'

const LabelButton = ({ isLoading, handleLabelRequest, data, t }) => (
  <button
    className={`activeCollection_requestLabelLink buttonComponent--small mx-0 my-2 me-sm-5 ${
      data.shipper_icon_url ? 'requestLabel_submitWithShipper' : ''
    }`}
    disabled={isLoading}
    key={data.id}
    onClick={() => handleLabelRequest(data)}
  >
    {data.shipper_icon_url && (
      <span className="requestLabel_shipperLogo">
        <img alt={data.shipper || ''} src={data.shipper_icon_url} />
      </span>
    )}
    <span>{isLoading ? t['submit.clicked.working'] : data.label}</span>
  </button>
)

LabelButton.propTypes = {
  data: PropTypes.object.isRequired,
  handleLabelRequest: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  t: PropTypes.object.isRequired,
}

export default LabelButton
